import Vue from "vue";
import Component from "vue-class-component";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ServiceStatusDto } from "../../dto/GenApi.iNotPaie.Dto/ServiceStatusDto";

@Component
export default class HealthCheckComponent extends Vue {
	public servicesStatus?: ServiceStatusDto[] = [];
	public isWating = 0;
	public version = "";

	public mounted(): void {
		this.refresh();
	}

	public refresh(): void {
    	if (!this.isWating) {
    		this.isWating++;
    		this.getServicesStatus();
    		this.isWating++;
    		this.getVersion();
    	}
	}

	public getServicesStatus(): void {
    	this.servicesStatus = [];

    	ServicesFactoryInstance.HealthCheckService.getServicesStatus(data => {
    		if (this.servicesStatus != undefined) {
    			for (let i = 0; i < data.length; i++) {
    				this.servicesStatus.push(data[i]);
    			}
    		}

    		this.isWating--;
    	});
	}

	public getVersion(): void {
    	this.version = "";
    	ServicesFactoryInstance.HealthCheckService.getVersion(data => {
    		this.version = data;
    		this.isWating--;
    	});
	}

	public getServiceState(state: any): string {
    	switch (state) {
    		case 0:
    			return "Inactif";
    		case 1:
    			return "Actif";
    		default:
    			return "Inconnu";
    	}
	}
}



// WEBPACK FOOTER //
// ./src/components/healthCheck/healthCheck.ts